import { onBeforeUnmount, onMounted, ref } from "vue";

export const useCommon = () => {
  const breakpoint = ref(false);
  const isMenuOpen = ref(false);
  const isModalOpen = ref(false);
  const isModalNum = ref(0);
  const scrollTop = ref(0);

  const html = () => document.getElementsByTagName("html")[0];

  const handleResize = () => {
    breakpoint.value = window.innerWidth <= 768;
  };

  const setViewport = () => {
    const tag = document.querySelector("meta[name='viewport']");
    if (!tag) return;
    const vp =
      window.innerWidth >= 769 && window.innerWidth < 1024
        ? "width=1024,user-scalable=yes,viewport-fit=cover"
        : "width=device-width,initial-scale=1.0,minimum-scale=1.0";
    tag.setAttribute("content", vp);
  };

  const toggleScrollLock = (open: boolean) => {
    const root = html();
    if (open) {
      scrollTop.value =
        document.documentElement.scrollTop || document.body.scrollTop;
      root.classList.add("scroll-prevent");
      root.style.top = `${-scrollTop.value}px`;
    } else {
      root.classList.remove("scroll-prevent");
      root.style.top = "";
      window.scrollTo(0, scrollTop.value);
    }
  };

  const menuToggle = () => {
    toggleScrollLock(!isMenuOpen.value);
    isMenuOpen.value = !isMenuOpen.value;
  };

  const modalToggle = (modalNum?: number) => {
    if (typeof modalNum === "number") {
      isModalNum.value = modalNum;
    }

    if (!isModalOpen.value && isModalNum.value === 0) {
      return;
    }

    toggleScrollLock(!isModalOpen.value);
    isModalOpen.value = !isModalOpen.value;

    if (!isModalOpen.value) {
      isModalNum.value = 0;
    }
  };

  const handleScrollFade = () => {
    const elms = document.querySelectorAll(".js-scrollfade");
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    elms.forEach((elm) => {
      const rect = (elm as HTMLElement).getBoundingClientRect().top;
      const offset = rect + scroll;
      const threshold = breakpoint.value
        ? offset - window.innerHeight + 20
        : offset - window.innerHeight + 100;
      if (scroll > threshold) {
        elm.classList.add("is-scrollin");
      }
    });
  };

  onMounted(() => {
    setViewport();
    handleResize();
    handleScrollFade();
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScrollFade);
    window.addEventListener("load", handleScrollFade);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", handleResize);
    window.removeEventListener("scroll", handleScrollFade);
    window.removeEventListener("load", handleScrollFade);
  });

  return {
    breakpoint,
    isMenuOpen,
    isModalOpen,
    isModalNum,
    menuToggle,
    modalToggle,
    handleScrollFade,
  };
};
